module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_3016.a6623b38.png";